import { FC } from 'react'
import { Link } from 'react-router-dom'
import { IconPaths, IconSize } from '../../../../../../_metronic/helpers/enumsUI'
import { KTSVG } from '../../../../../../_metronic/helpers/components/KTSVG'
import { PageHeading } from '../../../../../components/Header/PageHeading'
import { SituacaoProtocoloBadge } from '../../components/SituacaoProtocoloBadge'
import { CLASSE_LINK_OUTLINE } from '../../core/classeLinkOutline'
import { ProtocoloDetalhe } from '../../core/_models'

type Props = {
  protocolo?: ProtocoloDetalhe
  idProtocolo: number
  idEmpresa?: number
}

/**
 * Cabeçalho da comparação (mesmo formato do detalhe): a versão comparada como título, situação
 * como apoio e, à direita, o caminho de volta para essa versão — de onde se chega aqui.
 */
export const ComparacaoProtocoloHeading: FC<Props> = ({ protocolo, idProtocolo, idEmpresa }) => (
  <PageHeading
    title={
      protocolo ? `Comparar a versão ${protocolo.versao} — ${protocolo.nome}` : 'Comparar versões'
    }
    description={
      protocolo && (
        <span className='d-inline-flex flex-wrap align-items-center gap-3'>
          <SituacaoProtocoloBadge situacao={protocolo.situacao} />
          <span>Escolha com qual versão comparar.</span>
        </span>
      )
    }
    actions={
      <Link
        className={CLASSE_LINK_OUTLINE}
        to={`/apps/protocolos-triagem/${idProtocolo}?empresa=${idEmpresa}`}
      >
        <span className='me-2 d-flex align-items-center' aria-hidden='true'>
          <KTSVG path={IconPaths.ArrowLeft} size={IconSize.ExtraSmall} />
        </span>
        {protocolo ? `Voltar para a versão ${protocolo.versao}` : 'Voltar para a versão'}
      </Link>
    }
  />
)
